$(document).ready(function() {
    // if($('#sitewide-notice, #topbar').length) {
        $(window).resize(headerHeight);
        headerHeight();
    // }

    function headerHeight() {
        var postThumb       = $('.post-thumbnail .img-wrap');
        var header          = $('#header');
        var hero            = $('#hero');
        var slides          = $('#hero .slide');
        var cards           = $('.simple-content .cards');
        var adminBar        = $('#wpadminbar');
        var headerHeight    = (header.length ? header[0].offsetHeight : 0);
        var heroHeight      = (hero.length ? hero[0].offsetHeight : 0);
        var postThumbHeight = (postThumb.length ? postThumb[0].offsetHeight : 0);
        var adminBarHeight  = (adminBar.length ? adminBar[0].offsetHeight : 0);
        // var totalHeight       = parseFloat(noticeHeight) + parseFloat(topbarHeight) + parseFloat(breadcrumbsHeight);
        // console.log('postThumb: '+postThumbHeight+'px');
        // console.log('header: '+headerHeight+'px');
        // console.log('hero: '+heroHeight+'px');
        // console.log('total: '+totalHeight+'px');
        if($(window).width() >= 1200) {
            cards.css('paddingTop', parseFloat(postThumbHeight) + 70 - parseFloat(heroHeight));
        } else {
            cards.css('paddingTop', '');
        }
        if(slides.length) {
            slides.css('marginBottom', - (parseFloat(headerHeight) + parseFloat(adminBarHeight)));
            slides.css('paddingBottom', parseFloat(headerHeight) + parseFloat(adminBarHeight));
        }
    }
});
